// Authentication utilities

// These helpers remain for API calls that require Basic Auth to backend services
export const getAuthCredentials = (): string | null => {
  if (typeof window === 'undefined') return null
  const credentials = sessionStorage.getItem('authCredentials')
  console.log('Getting auth credentials:', credentials ? 'found' : 'not found')
  return credentials
}

export const setAuthCredentials = (credentials: string): void => {
  if (typeof window === 'undefined') return
  console.log('Setting auth credentials')
  sessionStorage.setItem('authCredentials', credentials)
}

export const clearAuthCredentials = (): void => {
  if (typeof window === 'undefined') return
  console.log('Clearing auth credentials')
  sessionStorage.removeItem('authCredentials')
}

export const isAuthenticated = (): boolean => {
  const authenticated = getAuthCredentials() !== null
  console.log('Checking if authenticated:', authenticated)
  return authenticated
}

// Enhanced fetch function that includes auth headers
export const authenticatedFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const credentials = getAuthCredentials()
  console.log('Making authenticated fetch to:', url, 'with credentials:', credentials ? 'yes' : 'no')
  
  const headers = {
    ...options.headers,
    ...(credentials && { 'Authorization': `Basic ${credentials}` })
  }

  return fetch(url, {
    ...options,
    headers
  })
}
